import z from 'zod';

export const studyContentSchema = z.object({
  content: z.string(),
  title: z.string(),
  graphJson: z.string().optional(),
});

export interface StudyContent extends z.infer<typeof studyContentSchema> {}
